import { render } from "./DocsAccountsTable.vue?vue&type=template&id=46b592e8&scoped=true"
import script from "./DocsAccountsTable.vue?vue&type=script&lang=js"
export * from "./DocsAccountsTable.vue?vue&type=script&lang=js"

import "./DocsAccountsTable.vue?vue&type=style&index=0&id=46b592e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b592e8"]])

export default __exports__